<div class="modern-user-menu">
  <button
    type="button"
    class="user-avatar-container"
    [attr.aria-label]="dataService.getTexts().UserSettings"
    (click)="navigateToSettings()"
  >
    <span class="user-avatar" aria-hidden="true">
      @if (avatar) {
        <img [src]="pic" alt="" class="avatar-image" (error)="clearProfilePicture()" />
      }
      @if (!avatar) {
        <i class="pi pi-user"></i>
      }
    </span>
    <span class="user-info">
      <span class="user-name" [title]="username || dataService.getTexts().UserSettings">{{
        username || dataService.getTexts().UserSettings
      }}</span>

      <span class="user-activeCostCenter" [pTooltip]="activeCostCenterTooltip" tooltipPosition="right">
        @if (showActiveCostCenterIndicator) {
          <span class="active-indicator-dot" aria-hidden="true"></span>
        }
        <span class="cost-center-name">{{ activeCostCenterName }}</span>
      </span>
    </span>
    <i class="pi pi-cog settings-icon" aria-hidden="true"></i>
  </button>
</div>
